module.exports = __webpack_public_path__ + "static/fb-social-435c23f084116e76cd6c8df79e6528a0.jpg";